export default __webpack_public_path__ + "static/media/jaison.44ba8f99.jpeg";